export const isBrowserWindowAvailable = (): boolean =>
  typeof window !== 'undefined';
